<template>
  <div id="hrms13x-detail-tab3" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab3">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRPM81X4']['10'] }}
      </h3>
    </div>
    <div id="tab3" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <div class="col-md-7 clearfix">
          <div class="detail-header" align="center">{{ labels['HRPM81X4']['20'] }}</div>
          <hrms-table :columns="tab3Table1" :data="data.table1" />
        </div>
        <div class="col-md-5 clearfix">
          <div class="detail-header" align="center">{{ labels['HRPM81X4']['60'] }}</div>
          <hrms-table :columns="tab3Table2" :data="data.table2" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hrms13x-detail-tab3',
  props: [ 'labels', 'data', 'tab3Table1', 'tab3Table2' ]
}
</script>


// WEBPACK FOOTER //
// detailTab3.vue?94c6cf50